import { useSelector } from "react-redux";
import { AccessContext } from "./AccessContext.js";
import { getAccessLevels } from "../../app/appSelectors";
import { useCallback } from "react";
import { ROLES } from "../../app/appConstants";

const AccessProvider = ({ children }) => {
    const accessLevels = useSelector(getAccessLevels);

    const checkAccess = useCallback((name) => {
        return accessLevels.indexOf(ROLES.ROOT) >= 0 || accessLevels.indexOf(name) >= 0;
    }, [accessLevels]);

    return (
        <AccessContext.Provider value={{ accessLevels, checkAccess }}>
            {children}
        </AccessContext.Provider>
    )
}

export default AccessProvider;
